/*
  BloomUp: product-page "People Also Bought" loader.
  Registers <product-recommendations> only when the theme has not already
  registered it, then fills the related-products section from Shopify's
  recommendations endpoint (the element's data-url).
*/
(function () {
  function register() {
    if (!window.customElements || customElements.get('product-recommendations')) return;

    class BuProductRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.buLoaded || !this.dataset.url) return;
        if (!this.classList.contains('related-products')) return;
        this.buLoaded = true;

        var el = this;
        var load = function () {
          fetch(el.dataset.url)
            .then(function (response) {
              if (!response.ok) throw new Error('recommendations ' + response.status);
              return response.text();
            })
            .then(function (text) {
              var html = document.createElement('div');
              html.innerHTML = text;
              var reco = html.querySelector('product-recommendations');
              if (reco && reco.innerHTML.trim().length) {
                el.innerHTML = reco.innerHTML;
              }
              document.dispatchEvent(new CustomEvent('currency:update'));
            })
            .catch(function (e) {
              el.buLoaded = false;
              console.error(e);
            });
        };

        if (!('IntersectionObserver' in window)) {
          load();
          return;
        }
        new IntersectionObserver(function (entries, observer) {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(el);
          load();
        }, { rootMargin: '0px 0px 400px 0px' }).observe(el);
      }
    }

    customElements.define('product-recommendations', BuProductRecommendations);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', register);
  } else {
    register();
  }
})();